import { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransition from "./components/PageTransition";
import LogoLoader from "./components/LogoLoader";
import AdminNavbar from "./pages/auth/Navbar/AdminNavbar.js";
import routes from "./routes/AppRoutes";

const Navbar = lazy(() => import("./components/Navbar/Navbar"));
const Footer = lazy(() => import("./components/Footer/Footer"));

export function App() {
  const location = useLocation();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const isAuthRoute = location.pathname.startsWith("/auth") && location.pathname !== "/auth/login";

  useEffect(() => {
    // If it's a first load, we show the loader briefly.
    // For subsequent navigations, we don't necessarily need a global blocker.
    if (isFirstLoad) {
      const timer = setTimeout(() => {
        setIsPageLoading(false);
        // Keep isFirstLoad true for 1.2s more so LogoLoader stays mounted during slide-down
        setTimeout(() => setIsFirstLoad(false), 1200);
      }, 1500);
      return () => clearTimeout(timer);
    } else {
      // Fast transition for subsequent routes
      setIsPageLoading(true);
      const timer = setTimeout(() => setIsPageLoading(false), 300);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, isFirstLoad]);

  return (
    <>
      {/* Show LogoLoader only on First Load or if explicitly loading on home */}
      {isFirstLoad && <LogoLoader isLoading={isPageLoading} />}

      <Suspense fallback={<div className="fixed inset-0 bg-white z-[99]" />}>
        {isAuthRoute && <AdminNavbar />}
        {!isAuthRoute && <Navbar />}

        <div className="flex flex-1">
          <div className={`flex-1 min-w-0 ${isAuthRoute ? "mt-14 md:ml-64" : "mt-0"}`}>
            <AnimatePresence mode="wait" onExitComplete={() => window.scrollTo(0, 0)}>
              <Routes location={location} key={location.pathname}>
                {routes.map((route, index) => (
                  <Route 
                    key={index} 
                    path={route.path} 
                    element={
                      <PageTransition>
                        <Suspense fallback={<div className="fixed inset-0 bg-white z-[99]" />}>
                          {route.element}
                        </Suspense>
                      </PageTransition>
                    } 
                  />
                ))}
              </Routes>
            </AnimatePresence>
            {!isAuthRoute && <Footer />}
          </div>
        </div>
      </Suspense>
    </>
  );
}

export default App;
